import { Alert, AlertTitle } from '@mui/material';
import * as React from "react";
import { ErrorIcon } from "./icons";
export const ErrorAlert = React.forwardRef(({ error }, ref) => {
    if (!error) {
        return null;
    }
    const { message, details } = formatError(error);
    return (React.createElement(Alert, { ref: ref, color: "error", icon: React.createElement(ErrorIcon, null) },
        React.createElement(AlertTitle, null, message),
        details));
});
function formatError(error) {
    if (typeof error == "string") {
        return {
            message: error,
        };
    }
    else if (error.message) {
        return {
            message: error.status ? `${error.status} ${error.message}` : error.message,
            details: error.details,
        };
    }
    else {
        return {
            message: error.toString(),
        };
    }
}
//# sourceMappingURL=ErrorAlert.js.map